/**
 * Generates a deterministic SHA-256 hex key from sqlQuery + parameters.
 * Falls back to djb2 hash if SubtleCrypto is unavailable.
 */
export async function generateCacheKey(
  sqlQuery: string,
  parameters: object,
): Promise<string> {
  const canonical = JSON.stringify({
    sqlQuery,
    parameters: sortObjectKeys(parameters as Record<string, unknown>),
  });

  try {
    const encoded = new TextEncoder().encode(canonical);
    const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return 'dw_' + hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return 'dw_' + djb2Hash(canonical);
  }
}

function sortObjectKeys(obj: Record<string, unknown>): Record<string, unknown> {
  const sorted: Record<string, unknown> = {};
  for (const key of Object.keys(obj).sort()) {
    sorted[key] = obj[key];
  }
  return sorted;
}

function djb2Hash(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) >>> 0;
  }
  return hash.toString(16);
}
